module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "reschedulingSenderCompletion"
    }
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替依頼が完了しました")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("依頼が承認または不承認されたらメールが届きますのでしばらくお待ちください")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a74192"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingSenderCompletion.vue
// module id = 709
// module chunks = 0